import type { FaireProductEntity } from "../../entity_types/product";

export const p_34aqgf7bzc: FaireProductEntity = {
  token: "p_34aqgf7bzc",
  type: "product",
  name: "Glassy Sun Hater Mojave Black/red Splat",
  brandToken: "b_u8merz42xh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5ce8fd5b7f7ccd17f288c7a25b6c384ca882aa695d226fb3776685df009b88e8.jpeg",
  galleryImageUrls: [],
  priceDollars: 32,
  description:
    "Experience ultimate sun protection and style with the SUN HATER MOJAVE BLACK/RED SPLAT. This bold and edgy design not only blocks harmful UV rays, but also makes a statement. Don't let the sun ruin your day, grab a SUN HATER today!",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:17.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
